module.exports = "/assets/dist/fonts/CircularStd-Book.ttf";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/shared/fonts/CircularStd-Book.ttf
// module id = 552
// module chunks = 9 10 27 29